import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyCart = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-card rounded-lg border border-border p-8 md:p-12 lg:p-16 text-center">
      <div className="max-w-md mx-auto space-y-4 md:space-y-6">
        <div className="w-20 h-20 md:w-24 md:h-24 mx-auto bg-muted rounded-full flex items-center justify-center">
          <Icon name="ShoppingCart" size={40} className="text-muted-foreground" />
        </div>

        <div className="space-y-2">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground">
            Your cart is empty
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Discover our collection of practical business strategy eBooks and start building your knowledge library today.
          </p>
        </div>

        <Button
          variant="default"
          size="lg"
          iconName="BookOpen"
          iconPosition="left"
          onClick={() => navigate('/e-book-catalog')}
        >
          Browse eBooks
        </Button>

        <div className="pt-6 space-y-3">
          <p className="text-sm font-medium text-foreground">Why choose us?</p>
          <div className="space-y-2 text-sm text-muted-foreground">
            <div className="flex items-center justify-center gap-2">
              <Icon name="CheckCircle" size={16} className="text-success" />
              <span>Proven frameworks and actionable insights</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <Icon name="CheckCircle" size={16} className="text-success" />
              <span>Instant download access</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <Icon name="CheckCircle" size={16} className="text-success" />
              <span>30-day money-back guarantee</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyCart;